let confirmRefreshTimer = null;

export const replaceConfirmRefreshTimer = (callback, delay) => {
    clearConfirmRefreshTimer();
    confirmRefreshTimer = setTimeout(callback, delay);
};

export const clearConfirmRefreshTimer = () => {
    if (confirmRefreshTimer) clearTimeout(confirmRefreshTimer);
    confirmRefreshTimer = null;
};
